import level from "@/services/modules/level";
import { mapGetters } from "vuex";
import * as types from "@/store/types";
import $thousandMask from "@/mixins/thousandMask";
const VerifyChip = () =>
  import(
    /* webpackChunkName: "VerifyChip" */ "@/components/AccountPage/Personal/VerifyChip/index"
  );

const PictureVerifyChip = () =>
  import(
    /* webpackChunkName: "PictureVerifyChip" */ "@/components/AccountPage/Personal/PictureVerifyChip/index"
  );

export default {
  name: "personal",
  mixins: [$thousandMask],
  components: {
    VerifyChip,
    PictureVerifyChip
  },
  data() {
    return {
      levels: []
    };
  },
  computed: {
    ...mapGetters({
      verifyInfo: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    }),
    checkPhoneStatus() {
      return (
        this.verifyInfo?.home_phone_verification_status === "VERIFIED" ||
        this.verifyInfo?.home_phone_verification_status === "SUBMITTED"
      );
    },
    contactStatus() {
      return this.verifyInfo?.email_verification_status === "VERIFIED" &&
        this.verifyInfo?.mobile_verification_status === "VERIFIED" &&
        this.checkPhoneStatus
        ? "VERIFIED"
        : "REJECTED";
    },
    personalStatus() {
      return this.verifyInfo?.personal_information_status;
    },
    identityStatus() {
      if (this.verifyInfo.is_in_auto_verification) {
        if (
          this.IDCardStatus === "VERIFIED" &&
          this.videoStatus === "VERIFIED"
        ) {
          return "VERIFIED";
        } else if (
          this.IDCardStatus === "PROCESSING" ||
          this.videoStatus === "PROCESSING"
        ) {
          return "PROCESSING";
        } else {
          return "REJECTED";
        }
      } else {
        return this.verifyInfo?.verification_image.status.value;
      }
    }
  },

  mounted() {
    this.getLevelsData();
  },
  methods: {
    getLevelsData() {
      level.getLevels().then(res => {
        this.levels = res.data.data;
      });
    }
  }
};
